export const LOGO_URL = "/brand/logo.png?v=4";
export const LOGO_ONBG_URL = "/brand/logo-onbg.png?v=4";

// Luxury oceanfront property photos (owner-provided)
const P = "/brand/photos";
export const STAIRCASE_IMG = `${P}/staircase.png`;
export const PHOTOS = [
  STAIRCASE_IMG,
  `${P}/pool.png`,
  `${P}/villa.jpg`,
  `${P}/entry.jpg`,
  `${P}/pavilion.jpg`,
];

// Random helper — a different photo per pick where possible
const pick = (exclude) => {
  const pool = exclude ? PHOTOS.filter((p) => p !== exclude) : PHOTOS;
  return pool[Math.floor(Math.random() * pool.length)];
};
export const randomPhoto = pick;

// Landing/auth page is always the spiral-staircase shot
export const HOME_IMG = STAIRCASE_IMG;

// Full-bleed app backdrops — randomized each load for variety
export const DASH_IMG = pick();
export const STREET_IMG = pick(DASH_IMG);
